import { getLocalizedString } from './get-localized-string.js';

const getLineItemDiscount = (discounts, price, locale)=>{
    const productDiscount = discounts === null || discounts === void 0 ? void 0 : discounts.find((discount)=>discount.type === 'ProductDiscount'
    );
    var ref, ref1;
    return {
        validFrom: (ref = productDiscount === null || productDiscount === void 0 ? void 0 : productDiscount.validFrom) !== null && ref !== void 0 ? ref : undefined,
        validUntil: (ref1 = productDiscount === null || productDiscount === void 0 ? void 0 : productDiscount.validUntil) !== null && ref1 !== void 0 ? ref1 : undefined,
        absoluteValue: (price === null || price === void 0 ? void 0 : price.total.discount.amount) || 0,
        relativeValue: price ? Number((price.total.discount.percentage * 100).toFixed(2)) : 0,
        description: getLocalizedString(locale, productDiscount === null || productDiscount === void 0 ? void 0 : productDiscount.description)
    };
};

export { getLineItemDiscount };
//# sourceMappingURL=get-line-item-discount.js.map
